'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dAbstract$002dSet from "./java.util.-Abstract-Set.js";
import * as $j_scala$002ecollection$002econvert$002e$002dJava$002dCollection$002dWrappers$0024$002dSet$002dWrapper$0024$0024anon$00242 from "./scala.collection.convert.-Java-Collection-Wrappers$-Set-Wrapper$$anon$2.js";
var $p;
/** @constructor */
function $c_sc_convert_JavaCollectionWrappers$SetWrapper(underlying) {
  this.qr = null;
  this.qr = underlying;
}
export { $c_sc_convert_JavaCollectionWrappers$SetWrapper as $c_sc_convert_JavaCollectionWrappers$SetWrapper };
$p = $c_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = new $j_java$002eutil$002e$002dAbstract$002dSet.$h_ju_AbstractSet();
$p.constructor = $c_sc_convert_JavaCollectionWrappers$SetWrapper;
/** @constructor */
function $h_sc_convert_JavaCollectionWrappers$SetWrapper() {
}
export { $h_sc_convert_JavaCollectionWrappers$SetWrapper as $h_sc_convert_JavaCollectionWrappers$SetWrapper };
$h_sc_convert_JavaCollectionWrappers$SetWrapper.prototype = $p;
$p.ae = (function(o) {
  try {
    return this.qr.ae(o);
  } catch (e) {
    if (false) {
      return false;
    } else {
      throw e;
    }
  }
});
$p.k = (function() {
  return this.qr.k();
});
$p.T = (function() {
  return this.qr.T();
});
$p.cV = (function() {
  return new $j_scala$002ecollection$002econvert$002e$002dJava$002dCollection$002dWrappers$0024$002dSet$002dWrapper$0024$0024anon$00242.$c_sc_convert_JavaCollectionWrappers$SetWrapper$$anon$2(this);
});
var $d_sc_convert_JavaCollectionWrappers$SetWrapper = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_convert_JavaCollectionWrappers$SetWrapper, "scala.collection.convert.JavaCollectionWrappers$SetWrapper", ({
  sS: 1,
  cg: 1,
  bt: 1,
  aU: 1,
  bc: 1,
  cl: 1,
  a: 1
}));
export { $d_sc_convert_JavaCollectionWrappers$SetWrapper as $d_sc_convert_JavaCollectionWrappers$SetWrapper };
